import { api } from '@/shared/services/api';

export type ChecklistGroup = 'essential' | 'master' | 'activation' | 'optional';

export interface ChecklistItem {
  id: string;
  group: ChecklistGroup;
  label: string;
  description?: string;
  done: boolean;
  cta: { label: string; href: string };
}

export interface SetupStatus {
  totalItems: number;
  completedCount: number;
  percentComplete: number;
  items: ChecklistItem[];
  groups: Record<ChecklistGroup, { label: string; completed: number; total: number }>;
  dismissedAt: string | null;
  completedAt: string | null;
  allComplete: boolean;
  notApplicableItems?: string[];
}

export async function getSetupStatus(): Promise<SetupStatus> {
  return api.get<SetupStatus>('/company/setup-status');
}

export async function dismissChecklist(): Promise<{ success: true }> {
  return api.post('/company/setup-status/dismiss');
}

export async function reopenChecklist(): Promise<{ success: true }> {
  return api.delete('/company/setup-status/dismiss');
}

export async function markCompletionSeen(): Promise<{ success: true }> {
  return api.post('/company/setup-status/completion-seen');
}

export async function markItemNotApplicable(itemId: string): Promise<{ success: true }> {
  return api.post('/company/setup-status/items/' + encodeURIComponent(itemId) + '/not-applicable');
}

export async function markItemApplicable(itemId: string): Promise<{ success: true }> {
  return api.delete('/company/setup-status/items/' + encodeURIComponent(itemId) + '/not-applicable');
}
